import { useEffect, useState } from "react";
import { client } from "../../sanity/client";
import { POSTS_QUERY_LIMITED } from "../../sanity/queries";
import Subtitle from "../typography/Subtitle";
import Title from "../typography/Title";
import Button from "../../shared/button/Button";
import { ArrowUpRightIcon } from "@phosphor-icons/react/dist/ssr";
import Description from "../typography/Description";
import Card from "./CardMain";
import CardMini from "./CardMini";
import { Post } from "../../blog/constants";

const ResourcesSection = ({ from }) => {
  const [posts, setPosts] = useState<Post[]>([
    {
      _id: "string",
      title: "string",
      slug: "string",
      date: "string",
      coverImage: "any",
      author: { name: "string" },
    },
    {
      _id: "string",
      title: "string",
      slug: "string",
      date: "string",
      coverImage: "any",
      author: { name: "string" },
    },
    {
      _id: "string",
      title: "string",
      slug: "string",
      date: "string",
      coverImage: "any",
      author: { name: "string" },
    },
    {
      _id: "string",
      title: "string",
      slug: "string",
      date: "string",
      coverImage: "any",
      author: { name: "string" },
    },
  ]);

  useEffect(() => {
    client
      .fetch<Post[]>(POSTS_QUERY_LIMITED)
      .then((res) => setPosts(res.slice(0, 4) || []));
  }, []);

  return (
    <section className="flex h-auto w-screen flex-col items-center gap-4 bg-gray-900 p-8 sm:px-32 md:px-8 lg:px-32">
      <Subtitle>Resources</Subtitle>
      <Title as={from == "resources" ? "h1" : undefined}>
        See what's coming next <br /> in AI-driven recruiting
      </Title>
      <a href="#joinUs">
        <Button
          variant="primary"
          size="base"
          className="!h-auto flex-row-reverse !py-2 hover:gap-6"
          icon={<ArrowUpRightIcon size={20} />}
        >
          Subscribe to #TinaTuesdays
        </Button>
      </a>
      <Description>
        Weekly Newsletter on Everything AI in Hiring. 10,000+ Subscribers
      </Description>
      <div className="relative mt-6 grid h-full w-full grow grid-cols-1 divide-y divide-gray-500 rounded-lg border border-gray-500 md:mt-10 md:grid-cols-5 md:grid-rows-3 md:divide-x">
        {posts?.map((post, i) => (
          <div className="md:col-span-3 md:row-span-1 first-of-type:md:col-span-2 md:first-of-type:row-span-3 [&:nth-of-type(2)]:md:!border-t-0">
            {i == 0 ? (
              <Card
                link={`/blog/${post?.slug}`}
                title={post?.title}
                type={"Blog"}
                image={{
                  src: post?.coverImage?.asset?.url,
                  width: post?.coverImage?.asset?.metadata?.dimensions?.width,
                  height: post?.coverImage?.asset?.metadata?.dimensions?.height,
                }}
                datePublished={post.date}
                className="[&>div]:max-h-none"
                // datePublished={post?.date ? formatDateTime(post?.date) : undefined}
              />
            ) : (
              <CardMini post={post} />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ResourcesSection;
